import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useMultiScreenServer } from 'services/multiscreen/hooks/useMultiScreenServer';
import { useOIDCClient } from 'services/oidc';
import { useOIDCTokenSet } from 'services/useOIDCTokenSet';
import { useSelectedProject } from 'services/useSelectedProject';
import { useCameraLayoutRepository } from 'services/useCameraLayoutRepository';
import { useSelectedEnvironment } from 'services/useSelectedEnvironment';
import { useEnvironments } from 'services/useEnvironments';

function useMultiScreenServerBinding() {
    const server = useMultiScreenServer();

    const oidcClient = useOIDCClient();
    const tokenSet = useOIDCTokenSet(oidcClient);
    useEffect(() => {
        if (!server) return;
        server.tokenSet = tokenSet;
    }, [server, tokenSet]);

    const selectedProject = useSelectedProject();
    useEffect(() => {
        if (!server) return;
        server.selectedProject = selectedProject;
    }, [server, selectedProject]);

    const environments = useEnvironments(selectedProject?.id);
    const selectedEnvironment = useSelectedEnvironment(environments);
    useEffect(() => {
        if (!server) return;
        server.selectedEnvironment = selectedEnvironment;
    }, [server, selectedEnvironment]);

    const layoutRepository = useCameraLayoutRepository();

    return {
        setPath: (path: string) => {
            if (!server) return;

            const m = path.match(/^\/cockpit\/(.*)$/);
            if (m) {
                const vehicleId = m[1];
                server.vehicleId = vehicleId;
                const layout = layoutRepository.get(vehicleId);
                server.cameraLayouts = layout.subscreens;
            } else {
                server.vehicleId = null;
            }
        },
    };
}

export function useMultiScreenSupport(rootPath: string) {
    const { setPath } = useMultiScreenServerBinding();

    const location = useLocation();
    useEffect(() => {
        const relpath = location.pathname.replace(new RegExp(`^${rootPath}`), '');
        setPath(relpath);
    }, [location.pathname, rootPath, setPath]);
}
